import moment from "moment";
import { API_URL, AUTH_TOKEN } from "../constants"
import date from 'date-and-time';

export const getTokenFromStorage = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN);
}

export const setTokenInStorage = (token: string) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN, token);
  }
}

export const removeTokenInStorage = () => {
  localStorage.removeItem(AUTH_TOKEN);
}

export const getApiUrlFromStorage = (): string | null => {
  return localStorage.getItem(API_URL);
}

export const setApiUrlInStorage = (apiUrl: string) => {
  if (apiUrl) {
    localStorage.setItem(API_URL, apiUrl);
  }
}

export const removeApiUrlInStorage = () => {
  localStorage.removeItem(API_URL);
}


export const getFormattedDateTime = (dateTime: string | null): string => {
  if (!dateTime) {
    return "";
  }
  const dateObj = new Date(dateTime);
  return date.format(dateObj, 'MMM DD, hh:mm A');
};

export const getTimeSpent = (startTime: string | null, endTime: string | null): string => {
  if (!startTime) {
    return "";
  }
  if (!endTime) {
    return date.subtract(new Date(), new Date(startTime)).toMinutes().toFixed(0).toString() + ' mins';
  }
  return date.subtract(new Date(endTime), new Date(startTime)).toMinutes().toFixed(0).toString() + ' mins';
}

export const getTodayDateStart = (): string => {
  return moment().format('YYYY-MM-DDT[00:00:00]Z');
}

export const getTodayDateEnd = (): string => {
  return moment().format('YYYY-MM-DDT[23:59:59]Z');
}